var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "city-picker-ui" },
    [
      _vm.typeDevice === "mobile"
        ? _c(
            "PopupUI",
            {
              attrs: {
                "disable-body-scroll": false,
                "inner-scroll-mobile": true
              },
              on: { "on-close": _vm.onClosePopup }
            },
            [
              _vm.typeCityPicker === "confirmation"
                ? _c("ConfirmationCityPicker", {
                    attrs: { location: _vm.location, city: _vm.city },
                    on: { "on-edit": _vm.onEditCity, "on-close": _vm.onClose }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.typeCityPicker === "select-city"
                ? _c("SelectCityPicker", {
                    attrs: { "type-device": _vm.typeDevice },
                    on: { "on-close": _vm.onClose }
                  })
                : _vm._e()
            ],
            1
          )
        : [
            _c(
              "span",
              {
                staticClass: "city-picker-ui__close",
                on: { click: _vm.onClosePopup }
              },
              [_c("Icon", { attrs: { icon: "r-close-window-rounded" } })],
              1
            ),
            _vm._v(" "),
            _vm.typeCityPicker === "confirmation"
              ? _c("ConfirmationCityPicker", {
                  attrs: { location: _vm.location, city: _vm.city },
                  on: { "on-edit": _vm.onEditCity, "on-close": _vm.onClose }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.typeCityPicker === "select-city"
              ? _c("SelectCityPicker", {
                  attrs: { "type-device": _vm.typeDevice },
                  on: { "on-close": _vm.onClose }
                })
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }